import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Card, Badge, Row, Col, Spinner } from "react-bootstrap";
import dayjs from "dayjs";
import { getPatronestado } from "../../api/common";

const calcularProximaFecha = (fecha, meses) => {
  return dayjs(fecha).add(meses, "month").format("DD/MM/YYYY");
};

const PatronEstadoView = () => {
  const { inventario } = useParams(); // MTO-PAT-098
  const [loading, setLoading] = useState(true);
  const [patron, setPatron] = useState(null);

  console.log(patron);

  useEffect(() => {
    consultarEstado();
  }, []);

  const consultarEstado = async () => {
    try {
      const resp = await getPatronestado("Patrones", {
        inventario
      });

      console.log(resp);
      setPatron(resp.data.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="text-center mt-5">
        <Spinner animation="border" />
        <p className="mt-2">Consultando estado del equipo patrón...</p>
      </div>
    );
  }

  if (!patron) {
    return (
      <div className="text-center mt-5">
        <Badge bg="danger">Equipo patrón no encontrado</Badge>
      </div>
    );
  }

    const obtenerEstadoActividad = (fechaVencimiento) => {
    const hoy = new Date();
    const vencimiento = new Date(fechaVencimiento);

    const diffDias = (vencimiento - hoy) / (1000 * 60 * 60 * 24);

    if (diffDias < 0) {
        return { texto: "Vencida", color: "danger", icono: "❌" };
    }
    if (diffDias <= 30) {
        return { texto: "Por vencer", color: "warning", icono: "⚠️" };
    }
    return { texto: "Activa", color: "success", icono: "✔️" };
    };


  return (
    <div className="container mt-4">

      {/* ===== TARJETA PRINCIPAL ===== */}
      <Card className="shadow-sm mb-4 w-100">
        <Card.Body className="w-100">
          <Row>
            <Col md={6}>
              <h5 className="fw-bold">{patron.item}</h5>
              <p className="mb-1"><strong>Marca:</strong> {patron.marca}</p>
              <p className="mb-1"><strong>Modelo:</strong> {patron.modelo}</p>
              <p className="mb-1"><strong>Serie:</strong> {patron.serie}</p>
              <p className="mb-0"><strong>Inventario:</strong> {patron?.inventario}</p>
            </Col>

            <Col md={3} className="text-md-end mt-3 mt-md-0">
              <h6>Estado</h6>
              <Badge bg={patron.estado === "Activo" ? "success" : "secondary"} pill>
                {patron.estado}
              </Badge>
            </Col>
            <Col md={3} className="text-md-end mt-3 mt-md-0">
                <img
                    src={patron?.foto || "/img/equipo-placeholder.png"}
                    alt="Equipo"
                    className="img-fluid"
                    style={{
                        maxWidth: "140px",
                        height: "140px",
                        objectFit: "cover",
                        borderRadius: "10px",
                        border: "1px solid #dee2e6"
                    }}
                    />
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* ===== ACTIVIDADES ===== */}
      <Row>
        {patron.actividades.map((act, index) => (
            
          <Col md={6} lg={4} key={index} className="mb-3">
            <Card className="h-100 border-0 shadow-sm w-100">
              <Card.Body className="w-100">
                <h6 className="fw-bold">{act.tipo}</h6>

                <p className="mb-1">
                  <strong>Fecha realizada:</strong><br />
                  {dayjs(act.fechaInicio).format("DD/MM/YYYY")}
                </p>

                <p className="mb-1">
                  <strong>Frecuencia:</strong><br />
                  {act.frecuencia} meses
                </p>
                <p className="mb-1">
                  <strong>Proxima actividad:</strong><br />
                </p>
            <div className="row align-items-center">
            {/* proxima fecha */}
            <div className="col-12 col-md-8">
              <div className="fw-bold">{act.nombre}</div>
              <strong className="text-muted">
                {new Date(act.fechaVencimiento).toLocaleDateString()}
              </strong>
            </div>

            {/* ESTADO */}
            <div className="col-12 col-md-4 text-md-end text-center mt-2 mt-md-0">
              <Badge bg={obtenerEstadoActividad(act.fechaVencimiento).color} className="fs-6">
                {obtenerEstadoActividad(act.fechaVencimiento).icono} {obtenerEstadoActividad(act.fechaVencimiento).texto}
              </Badge>
            </div>
            </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default PatronEstadoView;
